export const PLACEHOLDER = 'O que você procura na Leroy Merlin?';
